import { createReducer, on } from '@ngrx/store';

import { addMainOutletRoute } from './navigation-history.actions';

export interface NavigationHistoryState {
  lastPageVisited: string;
}
export const initialState: NavigationHistoryState = {
  lastPageVisited: '/jobs',
};


export const navigationHistoryReducer = createReducer(
  initialState,
  on(addMainOutletRoute, (state, {lastPage}) => ({ ...state, lastPageVisited: lastPage})),
);
